import axios from 'axios';

export function getWebClient() {

    let client;

    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
        client = axios.create({
            baseURL: 'http://localhost:8001',
            headers: {
                'Content-Type': 'application/json',
                'AdminApiAuthenticationToken': localStorage.getItem("adminAuthenticationToken")
            }
        });
    } else {
        client = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'AdminApiAuthenticationToken': localStorage.getItem("adminAuthenticationToken")
            }
        });
    }

    return client;
}

export function getDataTablesLanguage() {

    return {
        "decimal": "",
        "emptyTable": "Dati non disponibili per la visualizzazione",
        "info": "Visualizzati da _START_ a _END_ di _TOTAL_ record totali",
        "infoEmpty": "Visualizzati da 0 a 0 di 0 record totali",
        "infoFiltered": "(filtrati da _MAX_ record totali)",
        "infoPostFix": "",
        "thousands": ",",
        "lengthMenu": "Visualizza _MENU_ record per pagina",
        "loadingRecords": "Caricamento...",
        "processing": "",
        "search": "Ricerca:",
        "zeroRecords": "Nessun record trovato con i criteri impostati",
        "paginate": {
            "first": "Primo",
            "last": "Ultimo",
            "next": "Successivo",
            "previous": "Precedente"
        },
        "aria": {
            "orderable": "Order by this column",
            "orderableReverse": "Reverse order this column"
        }
    };

}

export function getRandomPin() {
    const list = "ABCDEFGHIJKLMNPQRSTUVWXYZ12345678";
    var res = "";
    for (var i = 0; i < 8; i++) {
        var rnd = Math.floor(Math.random() * list.length);
        res = res + list.charAt(rnd);
    }
    return res;
}

export function getNowDateTimeSqlServerFormat() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const milliseconds = now.getMilliseconds().toString().padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

